import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.assign";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makePropTypesFactory, makeValidatingTransformFactory } from "./factory";
export var makeResponsiveBreakpointPropTypes = makePropTypesFactory(function (vars) {
  return {
    display: PropTypes.shape({
      only: PropTypes.bool,
      value: PropTypes.oneOf(vars.displays).isRequired
    }),
    hide: PropTypes.shape({
      only: PropTypes.bool,
      value: PropTypes.bool.isRequired
    }),
    textAlign: PropTypes.shape({
      only: PropTypes.bool,
      value: PropTypes.oneOf(vars.textAlignments).isRequired
    }),
    textSize: PropTypes.shape({
      only: PropTypes.bool,
      value: PropTypes.oneOf(vars.textSizes).isRequired
    })
  };
});
export var makeResponsiveBreakpointLimitedPropTypes = makePropTypesFactory(function (vars) {
  return {
    display: PropTypes.shape({
      value: PropTypes.oneOf(vars.displays).isRequired
    }),
    hide: PropTypes.shape({
      value: PropTypes.bool.isRequired
    }),
    textAlign: PropTypes.shape({
      value: PropTypes.oneOf(vars.textAlignments).isRequired
    }),
    textSize: PropTypes.shape({
      value: PropTypes.oneOf(vars.textSizes).isRequired
    })
  };
});
export var makePropTypes = makePropTypesFactory(function (vars) {
  return {
    responsive: PropTypes.shape(vars.breakpoints.map(function (breakpoint) {
      return _defineProperty({}, breakpoint, PropTypes.shape(vars.breakpointsLimited.indexOf(breakpoint) === -1 ? makeResponsiveBreakpointPropTypes(vars) : makeResponsiveBreakpointLimitedPropTypes(vars)));
    }).reduce(function (acc, cv) {
      return Object.assign({}, acc, cv);
    }, {}))
  };
});
export var transform = function transform(props) {
  var className = props.className,
      responsive = props.responsive,
      rest = tslib_1.__rest(props, ["className", "responsive"]);

  return Object.assign({
    className: classNames(responsive !== undefined ? Object.keys(responsive).filter(function (breakpoint) {
      return responsive[breakpoint] !== undefined;
    }).map(function (breakpoint) {
      var names = {};
      var _responsive$breakpoin = responsive[breakpoint],
          display = _responsive$breakpoin.display,
          hide = _responsive$breakpoin.hide,
          textAlign = _responsive$breakpoin.textAlign,
          textSize = _responsive$breakpoin.textSize;

      if (display !== undefined) {
        var value = display.value;
        var only = "only" in display ? display.only === true : false;
        names["is-".concat(value, "-").concat(breakpoint).concat(only ? "-only" : "")] = value;
      }

      if (hide !== undefined) {
        var _value = hide.value;

        var _only = "only" in hide ? hide.only === true : false;

        names["is-hidden-".concat(breakpoint).concat(_only ? "-only" : "")] = _value;
      }

      if (textAlign !== undefined) {
        var _value2 = textAlign.value;

        var _only2 = "only" in textAlign ? textAlign.only === true : false;

        names["has-text-".concat(_value2, "-").concat(breakpoint).concat(_only2 ? "-only" : "")] = _value2;
      }

      if (textSize !== undefined) {
        var _value3 = textSize.value;

        var _only3 = "only" in textSize ? textSize.only === true : false;

        names["is-size-".concat(_value3, "-").concat(breakpoint).concat(_only3 ? "-only" : "")] = _value3;
      }

      return names;
    }).reduce(function (acc, cv) {
      return Object.assign({}, acc, cv);
    }, {}) : undefined, className)
  }, rest);
};
export var makeValidatingTransform = makeValidatingTransformFactory(makePropTypes, transform);